<template>
  <div class="pwmat-trial-download-background">
    <div class="pwmat-trial-download-banner">
      <div class="pwmat-trial-download-container">
        <div class="pwmat-trial-download-banner-title">软件下载</div>
      </div>

      <img class="pwmat-trial-download-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-trial-download-container">

     <div class="pwmat-trial-download-content">
       <div class="pwmat-trial-download-content-title">
         <div class="pwmat-trial-download-content-title-text">PWmat试用版(特别注意：(1)本试用版本主要是为了让大家体验PWmat的功能，而对于计算效率不能保障，因为不同机器的配置有很大的差别，导致软件的计算效率会有很大的不同;(2)PWmat适合大体系计算，对于只有几个原子的小体系，可能无法发挥GPU的优势;(3)本试用版本仅能用PWmat功能测试和科研教学使用，不能用公开发表文章.)</div>
         <div class="pwmat-trial-download-line"></div>
       </div>
       <div class="pwmat-trial-download-content-info">
         <p class="pwmat-trial-download-content-info-text">为了方便大家试用PWmat，PWmat除了推出基于docker的试用版本，还推出了可以自己安装编译环境的试用版本，具体需要编译的环境包括intel2016,cuda-10.1,此外，需要自备有英伟达显卡的GPU服务器，显卡驱动版本需要>=418.39。下面将给大家介绍编译环境以及PWmat的安装方法，需要注意的是我们推荐将PWmat安装在centos7系统环境中。具体如下：</p>
       </div>

       <div>
         <table class="pwmat-trial-download-introduce-table">
           <tr class="pwmat-trial-download-introduce-th">
             <th class="pwmat-trial-download-introduce-text-th">软件</th>
             <th class="pwmat-trial-download-introduce-text-th">版本</th>
             <th class="pwmat-trial-download-introduce-text-th">安装</th>
             <th class="pwmat-trial-download-introduce-text-th">下载</th>
             <th class="pwmat-trial-download-introduce-text-th">注意事项</th>
           </tr>
           <tr class="pwmat-trial-download-introduce-td" v-for="version in PWmatFreeDownload">
             <td class="pwmat-trial-download-introduce-text-td">{{version.soft}}</td>
             <td class="pwmat-trial-download-introduce-text-td">{{version.edition}}</td>
             <td class="pwmat-trial-download-introduce-text-td"><div v-html="version.install"></div></td>
             <td class="pwmat-trial-download-introduce-text-td"><a :href="version.downloadUrl">{{version.download}}</a></td>
             <td class="pwmat-trial-download-introduce-text-td"><div v-html="version.notice"></div></td>
           </tr>
         </table>
       </div>

 <!--      <div class="pwmat-trial-download-video">
         <video width="100%" height="100%" controls="controls">
           <source :src='PWMAT_VIDEO+"pwmat_cpu_docker.mp4"' type="video/mp4">
           Your browser does not support the video tag.
         </video>
       </div>
       <p class="pwmat-trial-download-content-note-text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.linux安装视频</p>
       <div class="pwmat-trial-download-video">
         <video width="100%" height="100%" controls="controls">
           <source :src='PWMAT_VIDEO+"pwmat_linux_docker.mp4"' type="video/mp4">
           Your browser does not support the video tag.
         </video>
       </div>-->


     </div>
    </div>
  </div>
</template>

<script>
  import {PWmatFreeDownload} from "../../helpers/softwareDownload"
  import {PWMAT_VIDEO} from "../../helpers/consts"

  export default {
    name: "companyIntroduce",
    data(){
      return {
        PWmatFreeDownload,
        PWMAT_VIDEO,

      }
    },
    methods:{

    }
  }
</script>

<style scoped>
  .pwmat-trial-download-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-trial-download-background{
    margin-top: 70px;
  }
  .pwmat-trial-download-banner{
    overflow:hidden;
  }
  .pwmat-trial-download-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-trial-download-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-trial-download-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-trial-download-content-title{
    padding-top: 50px;
  }
  .pwmat-trial-download-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-trial-download-content-note-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 0px;
  }
  .pwmat-trial-download-content-info{
    margin-top: 40px;
  }
  .pwmat-trial-download-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-trial-download-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }

  .pwmat-trial-download-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .pwmat-trial-download-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .pwmat-trial-download-introduce-td{
    height: 45px;
  }
  .pwmat-trial-download-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .pwmat-trial-download-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .pwmat-trial-download-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding: 16px;
  }
  .pwmat-trial-download-video{
    margin-top: 16px;
  }
  @media screen and (max-width:482px) {
    .pwmat-trial-download-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-trial-download-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-trial-download-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-trial-download-container{
      max-width: 1068px;
    }
  }

</style>
